<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" clearable placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" clearable placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证：" prop="idCard">
              <el-input v-model="form.idCard" clearable placeholder="请输入身份证"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="学历：">
              <el-select clearable filterable v-model="form.education" placeholder="请选择学历">
                <el-option v-for="(x,i) in $public.wenHuaCD_" :key="i" :label="x.label" :value="x.label" />
              </el-select>
            </el-form-item>
            <el-form-item label="就业形式：">
              <el-select clearable filterable v-model="form.jobStyle" placeholder="请选择就业形式">
                <el-option v-for="(x,i) in $public.jiuYeXS" :key="i" :label="x.label" :value="x.label" />
              </el-select>
            </el-form-item>
            <el-form-item label="就业群体：">
              <el-select clearable filterable v-model="form.jobGroup" placeholder="请选择就业群体">
                <el-option v-for="o in $public.gongzuoqunti" :key="o" :label="o" :value="o" />
              </el-select>
            </el-form-item>
            <el-form-item label="就业区域：">
              <el-select clearable filterable v-model="form.jobArea" placeholder="请选择就业区域">
                <el-option v-for="o in $public.gongzuodiqu" :key="o" :label="o" :value="o" />
              </el-select>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :arr="arrPlace1" :diss="dis" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"
                @click="paging_data.pageSize=paging_data.total=1,Filter_file({api:api,data:form,callback:_d=>tableData=_d})">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('fp')">删除</el-button>
      <el-button v-if="showBtn[4].isShow" style="padding: 0"><file_Upload :_url="$public.upload_url._i"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">下载模板</el-button>
      <el-button
        type="primary" v-if="showBtn[5].isShow" icon="el-icon-document-remove"
        v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)">导出数据</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" border max-height="550" style="width: 99.9%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip width="100px" v-for="(o,i) in baseInfo" :key="i" :prop="o.key" :label="o.value" :fixed="i>7?false:true"> -->
        <el-table-column show-overflow-tooltip width="100px" v-for="(o,i) in baseInfo" :key="i" :prop="o.key" :label="o.value"></el-table-column>
      </el-table>
      <paging :pagesData="paging_data" @set_page_number='get_page_number'></paging>
    </div>
    <!-- 编辑模态框 -->
    <el-dialog
      title="个人信息采集管理" :modal="false" :visible.sync="centerDialogVisible"
      @close="close_" width="1400px" :close-on-click-modal="false" center>
      <div>
        <!-- 基本信息 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号：">
                          <el-input style="width:193px;" v-model="editForm.idCard" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="户籍地址：">
                          <Area :value="area_data" :diss="dis" :name="arrPlace" @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="userSite" label="组：">
                          <el-input style="width:193px;" v-model="editForm.userSite" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="核实情况：">
                          <el-select size="mini" v-model="editForm.auditStatus" clearable placeholder="请选择">
                            <el-option v-for="o in $public.heShiQK" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>  
                        </el-form-item>
                        <el-form-item label="民族：">
                          <el-select size="mini" filterable v-model="editForm.nation" clearable placeholder="请选择">
                            <el-option v-for="o in $public.nation" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="当前状态：">
                          <el-select size="mini" filterable v-model="editForm.status" clearable placeholder="请选择">
                            <el-option v-for="o in $public.dangQianZT" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="劳动能力：">
                          <el-select size="mini" v-model="editForm.labor" clearable placeholder="请选择">
                            <el-option v-for="o in $public.laoDongNL" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="寸照：" >
                          <div class="head-img">
                            <el-upload class="avatar-uploader" :action="$api.url_upload_pu" :show-file-list="false" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1">
                              <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </div>
                        </el-form-item>
                        <el-form-item label="家庭住址：">
                          <el-input style="width:193px;" v-model="editForm.address" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="文化程度：">
                          <el-select size="mini" filterable v-model="editForm.education" clearable placeholder="请选择">
                            <el-option v-for="o in $public.wenHuaCD_" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="技能等级：">
                          <el-select size="mini" v-model="editForm.skillLevel" clearable placeholder="请选择">
                            <el-option v-for="o in $public.jiNengDJ" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="毕业时间：">
                          <el-date-picker style="width:193px;" value-format="yyyy-MM-dd" v-model="editForm.graduationTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="是否是贫困劳动力：">
                          <el-select size="mini" v-model="editForm.poorLaborYesOrNo" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 培训就业 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">培训就业</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="是否参加过培训：">
                          <el-select size="mini" v-model="editForm.isTraining" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="培训类别：">
                          <el-select size="mini" v-model="editForm.trainingType" clearable placeholder="请选择">
                            <el-option v-for="o in $public.peiXunLB" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="培训日期：">
                          <el-date-picker style="width:193px;" v-model="editForm.trainingTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="是否意愿参加培训：">
                          <el-select size="mini" v-model="editForm.trainingWish" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="意愿培训类别：">
                          <el-select size="mini" v-model="editForm.trainingWishType" clearable placeholder="请选择">
                            <el-option v-for="o in $public.peiXunLB" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="意愿培训时间：">
                          <el-date-picker style="width:193px;" value-format="yyyy-MM-dd" v-model="editForm.trainingWishTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="职业指导次数：">
                          <el-input style="width:193px;" v-model.number="editForm.careerGuideCount" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="创业服务次数：">
                          <el-input style="width:193px;" v-model.number="editForm.pioneerServiceCount" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="其它次数：">
                          <el-input style="width:193px;" v-model.number="editForm.otherCount" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="其它补贴金额(元)：">
                          <el-input style="width:193px;" v-model.number="editForm.otherAllowanceFee" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="培训机构名：">
                          <el-input style="width:193px;" v-model="editForm.trainingOrgnizationName" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="培训工种：">
                          <el-input style="width:193px;" v-model="editForm.traingJob" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="意愿培训工种：">
                          <el-input style="width:193px;" v-model="editForm.trainingWishJob" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="职业介绍次数：">
                          <el-input style="width:193px;" v-model.number="editForm.careerPushCount" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="职业培训次数：">
                          <el-input style="width:193px;" v-model.number="editForm.careerTrainingCount" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="未享受过就业服务">
                          <el-input style="width:193px;" v-model.number="editForm.notHavePioneerService" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 转移就业 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">转移就业</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="就业地点：">
                          <el-input style="width:193px;" v-model="editForm.workAddress" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="就业时间：">
                          <el-date-picker style="width:193px;" value-format="yyyy-MM-dd" v-model="editForm.workTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="月平均工资(元)：">
                            <el-input style="width:193px;" v-model="editForm.salary" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="就业形式：">
                          <el-select size="mini" v-model="editForm.jobStyle" clearable placeholder="请选择">
                            <el-option v-for="o in $public.jiuYeXS" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="其它就业形式说明：">
                          <el-input style="width:193px;" v-model="editForm.otherJobStyle" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="年度就业资金补助(元)：">
                          <el-input style="width:193px;" v-model="editForm.jobAllowance" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="就业单位名称：">
                            <el-input style="width:193px;" v-model="editForm.organizationName" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="所属行业产业：">
                          <el-select size="mini" v-model="editForm.belongToIndustry" clearable placeholder="请选择">
                            <el-option v-for="o in $public.suoShuHangYeCY" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="其它产业说明：">
                          <el-input style="width:193px;" v-model="editForm.otherIndustryDesc" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="是否签订劳动合同：">
                          <el-select size="mini" v-model="editForm.laborContract" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="是否缴纳社会保险：">
                          <el-select size="mini" v-model="editForm.type" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="是否返乡创业带动：">
                          <el-select size="mini" v-model="editForm.returnPioneer" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="有组织劳务输出：">
                          <el-select size="mini" v-model="editForm.organizationLaborOut" clearable placeholder="请选择">
                            <el-option v-for="o in $public.youZuZhiLaoWuSC" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="经帮扶实现就业：">
                          <el-select size="mini" v-model="editForm.helpToWork" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="帮扶时间：">
                          <el-date-picker style="width:193px;" value-format="yyyy-MM-dd" v-model="editForm.helpTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="就业群体：">
                          <el-select size="mini" v-model="editForm.jobGroup" clearable placeholder="请选择">
                            <el-option v-for="o in $public.gongzuoqunti" :key="o" :label="o" :value="o"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="就业区域：">
                          <el-select size="mini" v-model="editForm.jobArea" clearable placeholder="请选择">
                            <el-option v-for="o in $public.gongzuodiqu" :key="o" :label="o" :value="o"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="未转移就业类型：">
                          <el-select size="mini" v-model="editForm.type" clearable placeholder="请选择">
                            <el-option v-for="o in $public.weiZhuanYiJY" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="就业转失业日期：">
                          <el-date-picker value-format="yyyy-MM-dd" style="width:193px;" v-model="editForm.lostJobTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 就业意愿 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">就业意愿</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="是否有就业意愿：">
                          <el-select size="mini" v-model="editForm.jobWish" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="无就业意愿原因说明：">
                          <el-select size="mini" v-model="editForm.noJobWishReason" clearable placeholder="请选择">
                            <el-option v-for="o in $public.wuJiuYeYiYYYY" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="其它原因说明：">
                          <el-input style="width:193px;" v-model="editForm.otherReason" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第一意愿 就业意向地：">
                          <el-input style="width:193px;" v-model="editForm.jobWishAddress1st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第一意愿 期望月薪(元)：">
                          <el-input style="width:193px;" v-model="editForm.jobWishSalary1st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第一意愿 意向岗位(工种)：">
                          <el-input style="width:193px;" v-model="editForm.jobWish1st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="是否已欠薪：">
                          <!-- <el-input style="width:193px;" v-model="editForm.lostSalary" clearable placeholder="请输入"></el-input> -->
                          <el-select size="mini" v-model="editForm.lostSalary" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="欠薪是否已处理：">
                          <!-- <el-input style="width:193px;" v-model="editForm.dealLostSalary" clearable placeholder="请输入"></el-input> -->
                          <el-select size="mini" v-model="editForm.dealLostSalary" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="第二意愿 就业意向地：">
                          <el-input style="width:193px;" v-model="editForm.jobWishAddress2st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第二意愿 期望月薪(元)：">
                          <el-input style="width:193px;" v-model="editForm.jobWishSalary2st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第二意愿 意向岗位(工种)：">
                          <el-input style="width:193px;" v-model="editForm.jobWish2st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第三意愿 就业意向地：">
                          <el-input style="width:193px;" v-model="editForm.jobWishAddress3st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第三意愿 期望月薪(元)：">
                          <el-input style="width:193px;" v-model="editForm.jobWishSalary3st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="第三意愿 意向岗位(工种)：">
                          <el-input style="width:193px;" v-model="editForm.jobWish3st" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="求职意愿更新时间：">
                          <el-date-picker style="width:193px;" value-format="yyyy-MM-dd" v-model="editForm.jobWishTime" type="date" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 贫困户信息 -->
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">贫困户信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="户编号：">
                          <el-input style="width:193px;" v-model="editForm.residenceNo" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="人编号：">
                          <el-input style="width:193px;" v-model="editForm.personNo" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="与户主关系：">
                          <el-select size="mini" filterable v-model="editForm.relationShip" clearable placeholder="请选择">
                            <el-option v-for="(o,i) in $public.yuhuzhuguanxi" :key="i" :label="o" :value="o"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="务工时间(月)：">
                          <el-input style="width:193px;" v-model="editForm.workDuration" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="参加大病医疗：">
                          <el-select size="mini" filterable v-model="editForm.medical" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="在校生状况：">
                          <el-select size="mini" filterable v-model="editForm.studentStatus" clearable placeholder="请选择">
                            <el-option v-for="(o,i) in $public.zaixiaoshengzhuangkuang" :key="i" :label="o" :value="o"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="致贫原因：">
                          <el-select size="mini" filterable v-model="editForm.poorReason" clearable placeholder="请选择">
                            <el-option v-for="o in $public.checkList2" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="健康状况：">
                          <el-select size="mini" filterable v-model="editForm.healthy" clearable placeholder="请选择">
                            <el-option v-for="o in $public.jiankangzhuangtai" :key="o" :label="o" :value="o"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="劳动技能：">
                          <el-select size="mini" filterable v-model="editForm.laborSkill" clearable placeholder="请选择">
                            <el-option v-for="o in $public.laoDongNL" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="务工状况：">
                          <el-select size="mini" v-model="editForm.workStatus" clearable placeholder="请选择">
                            <el-option v-for="o in $public.wugongzhuangkuang" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="危房户：">
                          <el-select size="mini" v-model="editForm.dangerPoor" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="是否解决饮用水安全：">
                          <el-select size="mini" v-model="editForm.safeWater" clearable placeholder="请选择">
                            <el-option v-for="o in $public.options" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫属性：">
                          <el-select size="mini" filterable v-model="editForm.lostPoorInfo" clearable placeholder="请选择">
                            <el-option v-for="o in $public.tuopinzhuangtai" :key="o.label" :label="o.label" :value="o.label"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="脱贫年度：">
                          <el-date-picker style="width:193px;" v-model="editForm.lostPoorYear" value-format="yyyy" type="year" clearable placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="人均纯收入：">
                          <el-input style="width:193px;" v-model="editForm.perSalary" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="首次识别时间：">
                          <el-input style="width:193px;" v-model="editForm.poorFirstDate" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="贫困人员识别时间：">
                          <el-input style="width:193px;" v-model="editForm.poorInfoDate" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务日志录入 -->
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务日志录入</div>
            <div class="edit-right"  style="padding-top: 0">
              <div class="info-box">
                <div class="info-input">
                  <el-tabs type="border-card" v-model="activeName"  @tab-click="handleClick">
                    <el-tab-pane :label="item.value" :name="item.value" v-for="item in log" :key="item.key">
                      <div class="log">
                        <div>
                          <label for="desc">服务内容：</label>
                          <div id="desc">
                            <el-input type="textarea" v-model="serviceContent" :rows="3"></el-input>
                          </div>
                          <label for="res">服务结果：</label>
                          <div id="res">
                            <el-input type="textarea" v-model="serviceResult" :rows="3"></el-input>
                          </div>
                        </div>
                        <div>
                          <label for="img">上传图片：</label>
                          <div style="width: 100%;" id="img">
                            <el-upload
                              ref="uploadImg" list-type="picture-card" :class="{disabled:isMax}"
                              :action="$api.url_upload_pu" :file-list="fileList" :limit="3" 
                              :on-success="imgAdd" :on-error="error" :on-change="change"
                              :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                              <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible" :modal="false">
                              <img width="100%" :src="imageUrl" alt="">
                            </el-dialog>
                          </div>
                          <div style="margin: 10px 10px 0 0;float:right;">
                            <el-button type="primary" v-show="!isCreate" @click="submitLog()">提交日志</el-button>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务记录查询 -->
        <div class="edit-box" v-show="!isCreate">
          <div class="edit-item">
            <div class="edit-left">服务记录查询</div>
            <div class="edit-right"  style="padding-top: 0;flex: 0 0 95%;">
              <div class="info-box">
                <div class="info-input">
                  <el-table :data="logData" max-height="500" border style="width: 99.9%">
                    <el-table-column
                      v-for="o in $public.info" :key="o.key" show-overflow-tooltip
                      :prop="o.key" :label="o.value" align="center">
                    </el-table-column>
                    <el-table-column label="图片" type="expand">
                      <template slot-scope="props">
                        <div v-if="props.row.fileIds">
                          <span v-for="(o,i) in props.row.fileIds" :key="i" style="margin-left: 10px">
                            <el-image  style="width: 100px;height: 100px" :src="o" :preview-src-list="props.row.fileIds"></el-image>
                          </span>
                        </div>
                        <div v-else>
                          <span>无详情图片</span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <paging :pagesData="paging" @set_page_number='get_page'></paging>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="()=>{this.centerDialogVisible=false;delete this.selectRowId}">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下载模板框 -->
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    return{
      api: '/user/poorLabor',
      type: '28',
      form: {},
      centerDialogVisible: false,
      tableData: [],
      selectRow: [],
      baseInfo: [
        {key:'name',value:'姓名'},
        {key:'idCard',value:'户主身份证'},
        {key:'province',value:'省'},
        {key:'city',value:'市'},
        {key:'county',value:'县'},
        {key:'town',value:'镇'},
        {key:'village',value:'村'},
        {key:'userSite',value:'组'},
        {key:'auditStatus',value:'核实情况'},
        {key:'phone',value:'联系方式'},
        {key:'status',value:'当前状态'},
        {key:'labor',value:'劳动能力'},
        {key:'skillLevel',value:'技能等级'},
        {key:'nation',value:'民族'},
        {key:'education',value:'文化程度'},
        {key:'graduationTime',value:'毕业时间'},
        {key:'address',value:'家庭地址'},
        {key:'poorLaborYesOrNo',value:'是否贫困劳动力'},
      ],
      rules: {
        name: [ { required: true, message: '请输入姓名', trigger: 'blur' } ],
        idCard: [ { required: true, message: '请输入身份证号', trigger: 'blur' }, ],
        // phone: [ { required: true, message: '请输入电话', trigger: 'blur' } ],
      },
      isCreate: false,
      
      log: [
        {value:"结对帮扶",key:0},
        {value:"信息采集",key:1},
        {value:"就业服务",key:2},
        {value:"培训服务",key:3},
        {value:"创业服务",key:4},
        {value:"维权服务",key:5},
        {value:"其它服务",key:6}
      ],
      imageUrl:'',
      logType:1,
      activeName:'结对帮扶',
      logImg:[],
      serviceContent:'',
      serviceResult:'',
      fileList:[],
      isMax:false,
      dialogVisible: false,
      paging:{ currentPage:1, pageSize:50, total:0, },
      logData:[],
      pageIndex_log:1,
      imageUrl1: '',
      headImgId:'',
      isAudit: false,
    }
  },
  methods: {
    close_() {
      this.close()
      delete this.selectRowId
    },
    handleSelectionChange(val) {
      this.selectRow = val
      if (val.length > 0) {
        this.get_log_data(this.pageIndex_log, val[0].id)
        this.imageUrl1 = `${this.puUrl_x}/user/img/${val[0].imgId}`
      }
    },
    //分页
    get_page_number(pageNumber) {
      console.log(this.form)
      this.form.pageNumber = pageNumber
      // this.paging_data.currentPage = pageNumber
      this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
    },
    //提交请求
    submit() {
      let rD = {}
      rD = JSON.parse(JSON.stringify(this.editForm))
      delete rD.areaId
      
      rD.graduationTime = new Date(rD.graduationTime).getTime()
      rD.trainingTime = new Date(rD.trainingTime).getTime()
      rD.trainingWishTime = new Date(rD.trainingWishTime).getTime()
      rD.workTime = new Date(rD.workTime).getTime()
      rD.helpTime = new Date(rD.helpTime).getTime()
      rD.lostJobTime = new Date(rD.lostJobTime).getTime()
      rD.jobWishTime = new Date(rD.jobWishTime).getTime()
      rD.province = this.province
      rD.city = this.city
      rD.county = this.county
      rD.town = this.town
      rD.village = this.village
			rD.imgId = this.headImgId
			
			// —————————————————————————————————————————— 8.18 提交前保存一次this.selectRow ——————————————————————————————————————————
			this.selectRow[0] ? this.selectRowId = this.selectRow[0].id : ''
			// —————————————————————————————————————————— 8.18 提交前保存一次this.selectRow ——————————————————————————————————————————
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,rD).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else if (valid && this.isCreate === false) {
          delete rD.createTime
          this.$api.change(`${this.api}/modify`,rD).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else{
              this._status(res.data)
            }
          })
        } else {
          return false
        }
      })
    },
    //头像        
    handleAvatarSuccess1(res, file) {
      this.$message.success('上传成功！')
      this.imageUrl1 = URL.createObjectURL(file.raw)
      // console.log(res)
      this.headImgId = res.data
    },
    beforeAvatarUpload1(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) { this.$message.error('上传图片只能是 JPG、PNG 格式!') }
      if (!isLt2M) { this.$message.error('上传图片大小不能超过 2MB!') }
      return isJPG && isLt2M
    },
    //图片移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length < 3) { this.isMax = false }
    },
    //图片预览
    handlePictureCardPreview(file) {
      this.imageUrl = file.url
      this.dialogVisible = true
    },
    //图片状态改变时触发
    change(file,fileList) {
      if (fileList.length >= 3) { this.isMax = true }
    },
    //图片上传成功回调
    imgAdd(response,file, fileList) {
      this.fileList = fileList
      // this.$refs['uploadImg'].clearFiles()
    },
    //图片上传失败
    error(err, file, fileList) {
      this.$message.error('上传失败')
      this.isMax = fileList.length >= 3
    },
    //类型选择
    handleClick(tab, event) {
      this.logImg = []
      this.logType = parseInt(tab.index) + 1
    },
    //提交日志请求
    submitLog() {
      if (!this.serviceContent) {
        return this.$message.info('请输入服务内容')
      } else if (!this.serviceResult) {
        return this.$message.info('请输入服务结果')
      } else {
        this.fileList.forEach(o => {
          this.logImg.push(o.response.data)
				})
				// console.log(111111, this.selectRowId, this.selectRow)
				let targetId = this.selectRowId || this.selectRow[0].id
        let logData = {
          operateLogType: this.logType,
          targetId: targetId,
          fileIds: this.logImg.join(','),
          serviceContent: this.serviceContent,
          serviceResult: this.serviceResult
        }
        this.$api.createLog(logData).then(res =>{
          if (res.data.status === 0) {
            this.$message.success('提交日志成功！')
            this.$refs.uploadImg.forEach(o => { o.clearFiles() })
            this.serviceResult = this.serviceContent = ''
            this.get_log_data(this.pageIndex_log, targetId)
          } else{
            this._status(res.data)
          }
        })
      }
    },
    //日志分页
    get_page(pageNumber) {
      this.get_log_data(pageNumber, this.selectRow[0].id)
    },
    //对象日志记录查询
    get_log_data(page, id) {
      let request = { pageNumber: page, targetId: id }
      this.$api.getTargetLog(request).then(res => {
        if (res.data.status === 0) {
          this.paging.total = res.data.size
          this.paging.pageSize = res.data.pageSize
          this.logData = JSON.parse(res.data.data)
          console.log(this.logData)
          this.logData.forEach(o => {
            o.operateLogType = this.$public.type[o.operateLogType - 1]
            if (o.fileIds) {
              o.fileIds = o.fileIds.split(',')
              o.fileIds.forEach((item,index) => {
                o.fileIds[index] = this.puUrl_x+ '/user/img/' +item
              })
            }
          })
        } else {
          this._status(res.data)
        }
      })
    },
  },
  created() {
    this.isShowBtn("PoorLabor")//控制操作按钮的显示与隐藏
    this.getArea({ value: { areaId: 0 }, key: 0 })
    this.isAudit = this.userInfo.privilegesList.indexOf('user-info-check') != -1
    // console.log('%c权限','color:red',this.isAudit)
  },
  beforeRouteEnter: (to,from,next) => {
    next(vm => {
      console.log(vm.$route.params.info)
      if (vm.$route.params.info === undefined) {
        if (vm.userInfo.personal) {
          vm.$api.getData(vm.api,{areaId:vm.userInfo.areaId}).then(res => {
            if (res.data.status === 0) {
              vm.tableData = JSON.parse(res.data.data)
              if (vm.tableData.length === 0) {
                vm.$message.info('无相关信息')
              } 
              vm.paging_data.total = res.data.size
              vm.paging_data.pageSize = res.data.pageSize
            } else { vm._status(res.data) }
          })
        }
      } else {
        let Id = [
          vm.$route.params.info[0].provinceId,
          vm.$route.params.info[0].cityId,
          vm.$route.params.info[0].countyId,
          vm.$route.params.info[0].townId,
          vm.$route.params.info[0].villageId
        ]
        let placeId = Id.filter(x => x)
        let data = {
          areaId: placeId[placeId.length - 1],
          // id: vm.$route.params.info[0].id
          idCard: vm.$route.params.info[0].idCard
        }
        // vm.Filter_file({api:vm.api,data:data,callback:_d => vm.tableData = _d })
        vm.$api.getData(vm.api,data).then(res => {
          if (res.data.status === 0) {
            vm.tableData = JSON.parse(res.data.data)
            if (vm.tableData.length === 0) {
              vm.$message.info('无相关信息')
            } else {
              vm.handleSelectionChange(vm.tableData)
              vm.openBox('edit')
            }
            vm.paging_data.total = res.data.size
            vm.paging_data.pageSize = res.data.pageSize
          } else{
            this._status(res.data)
          }
        })
      }
      
    })
  },
  // mounted() {
  //   if (this.userInfo.personal) {
  //     console.log(this.form)
  //     setTimeout(()=>{
  //     },2000)
  //   }
  // }
}
</script>

<style lang='scss' scoped>
.index-header{overflow-x: auto;}
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.el-textarea .el-textarea__inner{resize: none;}
/* 模态框样式 */
.index .el-dialog__wrapper {
  overflow: hidden;
}
.index .el-dialog  {
  height: 100%;
  margin-top: 0!important;
  overflow-y: auto;
}
.head-img {
  height: 178px;
  width: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
}

.el-textarea .el-textarea__inner {
  resize: none;
}
.log {
  display: flex;
  flex-direction: row;
}
.log>div {
  flex: 1 1 40%;
  margin-left: 20px;
}
.log .disabled .el-upload--picture-card {
  display: none
}
.info-input .el-tabs--border-card>.el-tabs__content {
  padding: 10px 0 10px 0!important;
}  
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 178px;
  display: block;
}
</style>